var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWiperBaldes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.117 11.054L1.338 5.19a.974.974 0 01.287-1.2C8.68-1.27 15.6 1.514 18.752 3.985c.354.277.443.767.243 1.17L16.15 10.89c-.22.443-.728.657-1.206.533-4.078-1.063-7.529-.488-9.416.171-.54.188-1.166-.024-1.41-.54z",
    stroke: "#e95832",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.033 6.967L9.304 12M10.562 6.967L13.832 12",
    stroke: "#e95832",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/media/wiper_baldes.e5e5ecce.svg";
export { SvgWiperBaldes as ReactComponent };